import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class MiniAppAuthRequest
*  Запрос входа через Mini App
*/
export class MiniAppAuthRequest extends ActiveModel {

/**
  * payload
  * Сырая query-string с подписью платформы, без ведущего `?`
  */
  @ActiveField('')
  payload: string = ''
}
